import VideoCallout from './VideoCallout';

export default VideoCallout;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/VideoCallout/index.js